<template>
  <div id="default-layout">
    <AppSidebar />
    <div class="wrapper d-flex flex-column min-vh-100 bg-light">
      <AppHeader />
      <div
        class="body flex-grow-1"
        :class="{ 'body-container': isMarginTopShow }"
      >
        <CContainer lg class="main-container">
          <router-view />
        </CContainer>
      </div>
      <!-- <AppFooter /> -->
    </div>
  </div>
</template>
<script setup>
import { CContainer } from '@coreui/vue'
// import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
// 調整body的位置
const needMarginTopList = ['/registration/add']
const route = useRoute()

const isMarginTopShow = computed(() => {
  return needMarginTopList.includes(route.path)
})
</script>

<style lang="scss">
#default-layout {
  min-width: 540px;
  .body-container {
    margin-top: -57px;
  }
  .main-container {
    min-width: 500px;
  }
}
</style>
